export default "__VITE_ASSET__3fc4a5e4__"